module.exports = __webpack_public_path__ + "images/nest-d84336cec35b07004cd7d259af856841.jpg";